module.exports = __webpack_public_path__ + "img/TZS09471.70c460e5.jpeg";